import React from "react";
import { Progress } from "antd";
import { getFirmwareUpdateProgress,getHpcFirmwareUpdateProgress } from "@/fetch/fetchApi";
import fetchHandler from "@/fetch/fetchHandler";

const updateMap = new Map([
  ["", ""],
  ["loading", "命令下发中"],
  ["error", "升级失败"],
  ["success", "升级成功"],
]);

class UpdateProgress extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: 0,
      reqId:null,
      ids:[],
      updateStatus: this.props.updateStatus || "",
    };
    this.interval = null;
  }

  componentDidMount() {
    if (!this.props.updateStatus) {
      if (this.props.record.stubIds == null)
      {
        this.getProgress();
        this.interval = setInterval(() => {
          this.getProgress();
        }, 2000);
      } else {
        //hpc升级
        let items = [];
        let req = '';
        if (this.props.reqId.indexOf(',') != -1)
        {
          var re = [];
          var lis = JSON.parse(this.props.reqId);
          lis.forEach((id) => {
            items.push({
              stubId: id.stubId,
              updateStatus:'',
              data: 0,
            })
            re.push(id.reqId)
          });
          this.setState({
            reqId:re.join(',')
          })
          req = re.join(',');
        } else {
          this.setState({
            reqId:this.props.reqId
          })
          this.props.record.stubIds.forEach((id) => {
            items.push({
              stubId: id,
              updateStatus:'',
              data: 0,
            })
          });
          req =this.props.reqId;
        }
        this.setState({
          ids:items
        })
        this.getHpcProgress(req, this.props.record.from);

        this.interval = setInterval(() => {
          this.getHpcProgress(req, this.props.record.from);
        }, 2000);
      }
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }


  // 获取进度
  getHpcProgress = (reqId, from) => {
    fetchHandler(getHpcFirmwareUpdateProgress, {
      stubId: reqId,
      from:from,
    }).then((res) => {
      if (res && res.code === "success") {
        let ids = this.state.ids;
        let requestId = reqId;
        res.data.forEach((pane) => {
          ids.forEach((id) => {
            if (res.data.length == 1)
            {
              if (from != null && from != '')
              {
                requestId = pane.requestId;
              }
              id.data = pane.otaRate;
              if (pane.otaCode) {
                id.updateStatus = "error";
              } else {
                if (pane.otaRate === 0) {
                  id.updateStatus = "loading";
                }
                if (pane.otaRate > 0) {
                  id.updateStatus = "updating";
                }

                if (pane.otaRate === 100) {
                  id.updateStatus = "success";

                }
              }
            }
            else if (id.stubId == pane.stubId)
            {
              id.data = pane.otaRate;
              if (pane.otaCode) {
                id.updateStatus = "error";
              } else {
                if (pane.otaRate === 0) {
                  id.updateStatus = "loading";
                }
                if (pane.otaRate > 0) {
                  id.updateStatus = "updating";
                }

                if (pane.otaRate === 100) {
                  id.updateStatus = "success";

                }
              }
            }
          });
        });

        //遍历一下是不是都已经结束或者异常了，就停止
        let fi = true;
        ids.forEach((id) => {
          if (id.updateStatus != 'error' && id.updateStatus != 'success')
          {
            fi = false;
          }
        });
        console.info('喔喔')
        console.info(ids)

        if (fi)
        {
          clearInterval(this.interval);

            setTimeout(() => {
              this.setState({
                ids: ids,
              });
            }, 1000);
        }
        else {

          if (from != null && from != '')
          {
            clearInterval(this.interval);
            this.interval = setInterval(() => {
              this.getHpcProgress(requestId, null);
            }, 2000);
          }
          this.setState({
            ids: ids,
          });
        }



      }
    });
  };

  // 获取进度
  getProgress = () => {
    fetchHandler(getFirmwareUpdateProgress, {
      stubId: this.props.record.key,
    }).then((res) => {
      if (res && res.code === "success") {
        let status = "";
        if (res.data.otaCode) {
          status = "error";
        } else {
          if (res.data.otaRate === 0) {
            status = "loading";
          }
          if (res.data.otaRate > 0) {
            status = "updating";
          }

          if (res.data.otaRate === 100) {
            clearInterval(this.interval);

            setTimeout(() => {
              status = "success";
              this.setState({
                updateStatus: status,
              });
            }, 1000);
          }
        }

        this.setState({
          data: res.data.otaRate || 0,
          updateStatus: status,
        });
      }
    });
  };

  render() {
    const { updateStatus, ids } = this.state;
    return (
      <div>
      {ids.length == 0 ? (  <div>

        {updateMap.get(updateStatus) ? (
          <h4 style={{ textAlign: "center" }}>{updateMap.get(updateStatus)}</h4>
        ) : (
          <Progress percent={this.state.data} format={(percent) => `${percent}%`} />
        )}
        </div>) : (<div>


        {ids.map((v) => (


                    <div>
                      {updateMap.get(v.updateStatus) ? (
                      <h4 style={{ textAlign: "center" }}>{v.stubId}{updateMap.get(v.updateStatus)}</h4>
                    ) : (
                      <div>
                      <h4 style={{ textAlign: "center" }}>{v.stubId}升级中</h4>
                      <Progress percent={v.data} format={(percent) => `${percent}%`} />
                      </div>
                    )}
                    </div>
                  ))}

                    </div>)
  }

</div>

    );
  }
}

export default UpdateProgress;



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/updateProgress.js